module.exports = __webpack_public_path__ + "media/dashboard/assets/images/bg_conver-7862eff60c0090efc5ffe8545db91e14.png";